import React, { HtmlHTMLAttributes } from "react";
import styled, { css } from "styled-components";

import { IViewProps, View } from "core/decorators/View";
import { toBlockCss } from "../common/BlockStylesConfig";
import { TextInputViewConfig } from "./TextInputViewConfig";

export enum TextInputVariant {
	DEFAULT = "default",
	SEARCH = "search"
}

interface ITextInputViewProps extends IViewProps<TextInputViewConfig, TextInputVariant> {
	onChange: (value: string|File[]) => void;
	value: string|File[];
	placeholder?: string;
	error?: boolean;
	disabled?: boolean;
	ariaLabel?: string;
	htmlAttributes?: any
	type?: string;
}

interface IInputProps {
	config: TextInputViewConfig;
	disabled?: boolean;
	error?: boolean;
}

const StyledInput = styled.input<IInputProps>(({config, disabled, error}: IInputProps) => [
	toBlockCss(
		error ? config.errorState : disabled ? config.disabledState : config.defaultState
	),
	css`
		font-size: ${config.fontSize}

		&:focus {
			${toBlockCss(config.focusState)}
		}
	`
]);

interface ITextInputViewState {
	value: string;
}

@View({
	id: "text-input",
	configClass: TextInputViewConfig,
	variants: TextInputVariant
})
export class TextInputView extends React.PureComponent<
	ITextInputViewProps,
	ITextInputViewState
> {
	public render() {
		const { config, disabled, error, placeholder, style, value, type, ariaLabel, htmlAttributes } = this.props;

		return (
			<StyledInput
				config={config}
				disabled={disabled}
				error={error}
				onChange={this.handleChange}
				placeholder={placeholder}
				style={style}
				value={value}
				type={type}
				aria-label={ariaLabel}
				{...htmlAttributes}
			/>
		);
	}

	private handleChange = (e: any) => {
		this.props.type === "file"
			? this.props.onChange(e.target.files)
			: this.props.onChange(e.target.value);
	};
}



// WEBPACK FOOTER //
// ./src/common/views/textInput/TextInput.view.tsx